export default __webpack_public_path__ + "static/media/blueberry.15f439eb.jpg";